var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassRadioGroup",
    {
      key: "pagination-limit-" + _vm.limit,
      attrs: {
        value: _vm.limit,
        label: _vm.$t.__(
          "listing.settings.ListingSettings.tabs.rows.number_per_page"
        )
      },
      on: {
        input: function(newValue) {
          _vm.$emit("updateLimit", newValue)
        }
      }
    },
    _vm._l(_vm.limitOptions, function(limitOption) {
      return _c("CompassRadio", {
        key: "rows-per-page-option-" + limitOption,
        attrs: { modelValue: limitOption }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }